/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';

import BookCover from './BookCover';
import Card from './Card';
import Heading from './Heading';
import Highlighter from './Highlighter';
import Text from './Text';

import { COVER_WIDTH, COVER_WIDTH_MOBILE, COVER_HEIGHT } from '../constants';

export default function CardSelectable({
  isSelected,
  onClick,
  searchWords,
  subtitle,
  thumbnail,
  title,
  to,
}) {
  const innerStyles = isSelected
    ? {
        position: 'relative',
        right: '1px',
        bottom: '1px',
        borderRadius: 6,
      }
    : {
        borderRadius: 'button',
      };
  const bookStyles = isSelected
    ? {
        bottom: '-17px',
        right: '-29px',
      }
    : {
        bottom: '-16px',
        right: '-28px',
      };
  return (
    <Card isActive={isSelected} onClick={onClick} to={to}>
      <div sx={{ ...sx.inner, ...innerStyles }}>
        <div sx={sx.meta}>
          {title && (
            <Heading as="h2" sx={sx.heading} truncated>
              {searchWords ? (
                <Highlighter
                  highlightClassName="highlighter-color"
                  autoEscape={false}
                  searchWords={searchWords}
                  textToHighlight={title}
                />
              ) : (
                title
              )}
            </Heading>
          )}
          {subtitle && (
            <Text as="p" sx={sx.authors} truncated>
              {subtitle}
            </Text>
          )}
        </div>
        <div>
          <div sx={{ ...sx.book, ...bookStyles }}>
            <BookCover
              thumbnail={thumbnail}
              thumbnail2x={thumbnail}
              title={title}
              width="60%"
            />
          </div>
        </div>
      </div>
    </Card>
  );
}

const sx = {
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
  },
  book: {
    width: [
      COVER_WIDTH_MOBILE,
      COVER_WIDTH_MOBILE,
      COVER_WIDTH_MOBILE,
      COVER_WIDTH,
    ],
    height: COVER_HEIGHT - 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    position: 'relative',
    transform: 'rotate(2deg)',
  },
  meta: {
    paddingY: 'm',
    paddingLeft: 's',
    paddingRight: 'm',
    maxWidth: [
      `calc(100% - ${COVER_WIDTH_MOBILE}px)`,
      `calc(100% - ${COVER_WIDTH_MOBILE}px)`,
      `calc(100% - ${COVER_WIDTH_MOBILE}px)`,
      `calc(100% - ${COVER_WIDTH}px)`,
    ],
  },
  heading: {
    color: 'olive',
    display: 'block',
    fontSize: 'xs',
    fontWeight: 'heading',
    lineHeight: 'heading',
    marginBottom: 'xs',
  },
  subheading: {
    color: 'blueberry.80',
    display: 'block',
    fontSize: 'xs',
    fontWeight: 'heading',
    lineHeight: 'heading',
    marginBottom: 10,
  },
  authors: {
    color: 'blueberry.80',
    display: 'block',
    fontSize: 'xxs',
    fontWeight: 'heading',
    lineHeight: 'heading',
  },
};
